/**
 * Show a fatal message in #root when bootstrap fails before React mounts.
 * Uses DOM APIs only (no innerHTML with untrusted strings).
 */
export function showFatalErrorInRoot(title: string, message: string): void {
  const root = document.getElementById("root");
  if (!root) return;

  root.replaceChildren();

  const wrap = document.createElement("div");
  wrap.style.padding = "1.5rem";
  wrap.style.fontFamily = "system-ui, sans-serif";
  wrap.style.maxWidth = "40rem";

  const h1 = document.createElement("h1");
  h1.style.fontSize = "1.25rem";
  h1.style.marginBottom = "0.75rem";
  h1.textContent = title;

  const pre = document.createElement("pre");
  pre.style.whiteSpace = "pre-wrap";
  pre.style.color = "#b91c1c";
  pre.style.fontSize = "0.875rem";
  pre.textContent = message;

  const hint = document.createElement("p");
  hint.style.marginTop = "1rem";
  hint.style.color = "#64748b";
  hint.style.fontSize = "0.875rem";
  hint.textContent =
    "If this is a deployed build, confirm VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY are set for that environment in Vercel (or your host) and redeploy.";

  wrap.append(h1, pre, hint);
  root.appendChild(wrap);
}
